import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { HttpService } from '../../../services/common/http/common.http.service';
import { PermissionService } from '../../../services/permission.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import {
  GetImagemLicencaPessoa,
  IGetLicencas,
} from './listagem-licencas-layout.model';
import { formatDate } from '../../../utils/utility-functions';
import { AppExportBase64 } from '../../../services/exportBase64/exportBase64.service';

@Component({
  selector: 'app-listagem-licencas-layout',
  templateUrl: './listagem-licencas-layout.component.html',
  styleUrls: ['./listagem-licencas-layout.component.scss'],
})
export class ListagemLicencasLayoutComponent implements OnInit {
  tableData: IGetLicencas[] = [];
  expandirCardsMobile: boolean = false;
  loader: boolean = false;

  pesquisaParams = {
    Pesquisa: '',
    DtInicio: '',
    DtFim: '',
    Pagina: 0,
    TamanhoPagina: 8,
    MaxPages: 1,
  };

  constructor(
    private httpService: HttpService,
    private permissionService: PermissionService,
    private router: Router,
    private toast: ToastrService,
    private changeDetectorRef: ChangeDetectorRef,
    private exportBase64Service: AppExportBase64
  ) {}

  ngOnInit() {
    this.permissionService.getPermission();
    this.getLicencas();
    this.changeDetectorRef.detectChanges();
  }

  tableColumns = [
    {
      header: 'Nome e CPF',
      key: '',
      keyArray: ['TxNome', 'TxCpf'],
      type: 'textArray',
    },
    { header: 'Licença', key: 'LicencaTxNome', type: 'text' },
    { header: 'Entrada', key: 'DtInicioFormated', type: 'text' },
    { header: 'Retorno', key: 'DtFimFormated', type: 'text' },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Editar',
          img: 'assets/images/edit.svg',
          action: (item: any) => this.editItem(item),
          condition: (item: any) => true,
        },
        {
          label: 'Baixar Licença',
          img: 'assets/images/download-icon.svg',
          action: (item: any) => this.downloadLicenca(item),
          condition: (item: any) => true,
        },
      ],
    },
  ];

  rowsMobile = [
    {
      header: 'Nome e CPF',
      key: '',
      keyArray: ['TxNome', 'TxCpf'],
      type: 'textArray',
    },
    { header: 'Licença', key: 'LicencaTxNome', type: 'text' },
    { header: 'Entrada', key: 'DtInicioFormated', type: 'text' },
    { header: 'Retorno', key: 'DtFimFormated', type: 'text' },
    {
      header: 'Ações',
      key: 'acoes',
      type: 'buttons',
      buttons: [
        {
          img: 'assets/images/edit.svg',
          label: 'Editar',
          action: (item: any) => this.editItem(item),
          condition: (item: any) => true,
        },
        {
          label: 'Baixar Licença',
          img: 'assets/images/edit.svg',
          action: (item: any) => this.downloadLicenca(item),
          condition: (item: any) => true,
        },
      ],
    },
  ];

  getLicencas(page?: number) {
    this.loader = true;
    const params = this.pesquisaParams;

    this.httpService.useGet('LicencasCriadas', params).subscribe({
      next: (response: any) => {
        const data = response.DataSet;

        this.tableData = data.map((item: IGetLicencas) => {
          return {
            IdLicencaPessoa: item.IdLicencaPessoa,
            LicencaId: item.LicencaId,
            LicencaTxNome: item.Licenca.TxNome,
            DtInicio: item.DtInicio,
            DtFim: item.DtFim,
            DtInicioFormated: formatDate(item.DtInicio),
            DtFimFormated: formatDate(item.DtFim),
            PessoaId: item.PessoaId,
            TxNome: item.Pessoa.TxNome,
            TxCpf: item.Pessoa.TxCpf,
          };
        });
        this.pesquisaParams.MaxPages =
          Math.ceil(response.Total / this.pesquisaParams.TamanhoPagina) || 1;
        this.loader = false;
      },
      error: (_error: any) => {
        this.loader = false;
        this.toast.error(
          'Não foi possível buscar as disciplinas. Tente novamente!'
        );
      },
    });
  }

  mudarPagina(pagina: number) {
    this.pesquisaParams.Pagina = pagina;
    this.getLicencas();
  }

  editItem(item: any) {
    const licencaItem = this.tableData.find(
      (x: any) => x.LicencaId === item.LicencaId
    );
    if (licencaItem) {
      this.router.navigate(['recursos-humanos/registrar-licenca'], {
        queryParams: {
          LicencaId: licencaItem.LicencaId,
          IdLicencaPessoa: licencaItem.IdLicencaPessoa,
          PessoaId: licencaItem.PessoaId,
          DtInicio: new Date(licencaItem.DtInicio),
          DtFim: new Date(licencaItem.DtFim),
          Editando: true,
        },
      });
    } else {
      Swal.fire({
        title: 'Atenção!',
        text: 'Licença não encontrada.',
        icon: 'error',
        confirmButtonText: 'Ok',
      });
    }
  }

  downloadLicenca(item: any) {
    const IdLicencaPessoa = item.IdLicencaPessoa;
    if (IdLicencaPessoa) {
      Swal.fire({
        title: 'Deseja baixar a imagem?',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        confirmButtonColor: '#37aaF7',
        cancelButtonText: 'Não',
      }).then((result) => {
        if (result.isConfirmed) {
          this.httpService
            .useGet('ImagemLicencaPessoa', { IdLicencaPessoa })
            .subscribe({
              next: (response: GetImagemLicencaPessoa) => {
                this.exportBase64Service.downloadJPG(
                  response.Data,
                  response.Name
                );
              },
              error: (_error: any) => {
                this.toast.error('Não foi possível baixar a imagem!');
              },
            });
        }
      });
      return;
    }
    this.toast.error('Não foi possível encontrar a licença selecionada!');
    return;
  }

  exportExcel() {
    this.loader = true;
    const body = {
      TxPesquisar: this.pesquisaParams.Pesquisa,
      DtInicio: this.pesquisaParams.DtInicio,
      DtFim: this.pesquisaParams.DtFim,
    };

    this.httpService.useGet('LicencaExportExcel', body).subscribe({
      next: (response: any) => {
        this.exportBase64Service.downloadExcel(response.DataSet, 'licencas');
        this.loader = false;
      },
      error: (_error) => {
        this.toast.error('Ocorreu um erro ao exportar excel. Tente novamente!');
        this.loader = false;
      },
    });
  }

  timer: ReturnType<typeof setTimeout> | null = null;
  onChangeSearch() {
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      this.getLicencas();
    }, 800);
  }

  navigateRegistrarLicenca() {
    this.router.navigate(['recursos-humanos/registrar-licenca']);
  }
}
